var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"h5"}},[_c('iframe',{staticStyle:{"height":"100vh"},attrs:{"src":_vm.url,"frameborder":"0","width":"100%","height":"100vh"}})])}
var staticRenderFns = []

export { render, staticRenderFns }